export type CampaignQuoteTemplateItemModel = {
  base_price?: number,
  cache_key: number,
  campaign_quote_template_id?: number,
  campaign_quote_template_section_id?: number,
  compulsory?: boolean,
  data?: {
    agency_price?: number,
    default_quote_item_id?: number,
    hidden?: boolean,
    publication_week?: number,
    tags?: string[],
  },
  description?: string,
  display_title?: string,
  id: number,
  internal_notes?: string,
  item_type?: 'custom' | 'orderable',
  locked?: boolean,
  options?: any,
  options_string?: string,
  order_bundle_id?: number,
  package_id?: number,
  price?: number,
  price_override?: number,
  price_type?: 'fixed' | 'percentage',
  processing_fee?: number,
  provider_id?: number,
  provider_price_list_item_id?: number,
  publication_edition_id?: number,
  publication_id?: number,
  publication_package_id?: number,
  quantity?: number,
  quote_total?: number,
  required_by?: string,
  required_days_from_start?: number,
  row_title?: string,
  selected?: boolean,
  service_id?: number,
  service_product_id?: number,
  sort?: number,
  title?: string,
  type?: 'CampaignQuoteTemplateItem',
}

export type CampaignQuoteTemplateItemOption = {
  id: number,
  title?: string,
  value: {
    id: number,
    title?: string,
    price?: number,
  },
}

export type CreateMultipleCampaignQuoteTemplateItemsPayload = {
  campaign_quote_template_id: number,
  campaign_quote_template_section_id: number,
  data?: object,
  item_type: 'orderable',
  options?: CampaignQuoteTemplateItemOption[],
  order_bundle_id?: number,
  price_list_item_id?: number,
  product_unlock_ids?: number[],
  publication?: {
    id: number,
  },
  publication_edition_ids?: number[],
  title?: string,
}

export type CampaignQuoteTemplateItemRequestOptions = {}

const state = {
  base_price: undefined,
  campaign_quote_template_id: undefined,
  campaign_quote_template_section_id: undefined,
  compulsory: false,
  data: {
    agency_price: undefined,
    default_quote_item_id: undefined,
    hidden: false,
    publication_week: undefined,
    tags: [],
  },
  description: '',
  display_title: '',
  id: undefined,
  internal_notes: undefined,
  item_type: undefined,
  locked: false,
  options: undefined,
  options_string: undefined,
  order_bundle_id: undefined,
  package_id: undefined,
  price: '',
  price_type: 'fixed',
  price_override: '',
  processing_fee: undefined,
  provider_id: undefined,
  provider_price_list_item_id: undefined,
  publication_edition_id: undefined,
  publication_id: undefined,
  publication_package_id: undefined,
  quantity: undefined,
  required_by: undefined,
  required_days_from_start: undefined,
  row_title: undefined,
  selected: true,
  service_id: undefined,
  service_product_id: undefined,
  sort: undefined,
  title: undefined,
}

export const requiredFields = [
  { key: 'campaign_quote_template_id' },
  { key: 'campaign_quote_template_section_id' },
  { key: 'price', validation: (price: string) => price !== '' && !Number.isNaN(Number(price)) },
  { key: 'title' },
]

export default state
